import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type TapCategory = {
  tap_category_id?: number; // 탭 카테고리 idx
  parents_id?: number; // 상위 idx
  tap_category_name?: string; // 카테고리 명
  type?: string; // 타입
  is_show?: string; // 노출 여부
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] TapCategory
   * --
   */
  getTapCategories: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_TAP_CATEGORY, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] TapCategory
   * --
   */
  getTapCategory: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_TAP_CATEGORY, {
        tap_category_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] TapCategory
   * --
   */
  createTapCategory: async (body: TapCategory) => {
    try {
      const res = await $http.post(APIConstant.CREATE_TAP_CATEGORY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] TapCategory
   * --
   */
  updateTapCategory: async (body: TapCategory) => {
    try {
      const { tap_category_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_TAP_CATEGORY, {
        tap_category_id: tap_category_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] TapCategory
   * --
   */
  deleteTapCategory: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_TAP_CATEGORY, {
        tap_category_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
